import axios from "axios";
import { Message } from "element-ui";
import { API_BASE } from "./config";

function showRequestError(message) {
  Message({
    type: "error",
    message: message || "接口请求失败",
    showClose: true,
    duration: 3000
  });
}

function normalizeError(message, response, config) {
  const normalizedError = new Error(message || "接口请求失败");
  normalizedError.response = response;
  normalizedError.config = config;
  return normalizedError;
}

const http = axios.create({
  baseURL: API_BASE,
  timeout: 15000
});

http.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  (response) => {
    const payload = response.data;
    if (payload && typeof payload === "object" && payload.code !== undefined && payload.code !== 0) {
      const message = payload.message || "接口请求失败";
      const normalizedError = normalizeError(message, response, response.config);
      if (response.config.showErrorMessage !== false) {
        showRequestError(message);
        normalizedError.__toastShown = true;
      }
      return Promise.reject(normalizedError);
    }
    return payload;
  },
  (error) => {
    const message = error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : "接口请求失败";
    const normalizedError = normalizeError(message, error.response, error.config);
    if (!error.config || error.config.showErrorMessage !== false) {
      showRequestError(message);
      normalizedError.__toastShown = true;
    }
    return Promise.reject(normalizedError);
  }
);

export default http;
